import toast from './toast';

const openCashDrawer = async (alert = false) => {
  try {
    await fetch('http://localhost:3131/open-drawer', { method: 'POST' });
  } catch (error) {
    if (alert) {
      toast.error('Failed to connect to cash drawer. Please check your connection!');
    }
  }
};

export { openCashDrawer };
